<template>
  <div class="info-box static">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="overflow-y-auto px-2.5 flex-1"
    >
      <ul class="grid gap-x-3" style="grid-template-columns: 1fr 15% 15% 1fr">
        <el-form-item
          label="费用名称"
          prop="name"
          :rules="[
            { required: true, message: '请输出费用名称', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="类型"
          prop="d_office_expense_type_pid"
          :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
        >
          <el-tree-select
            v-model="state.model.d_office_expense_type_id"
            :data="state.lx_data"
            node-key="id"
            :props="{
              children: 'children',
              label: 'name',
            }"
            :expand-on-click-node="false"
            clearable
            default-expand-all
            @current-change="onLxChange"
          >
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadLx"
              >
                刷新
              </el-button>
            </template>
          </el-tree-select>
        </el-form-item>
        <el-form-item
          label="支付渠道"
          prop="payment_method"
          :rules="[{ required: true, message: '请选择类型', trigger: 'blur' }]"
        >
          <el-select v-model="state.model.payment_method">
            <el-option
              v-for="item in $base.Office_Expense_Apply_Payment_Method"
              :key="item"
              :label="item.Text"
              :value="item.Key"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="乙方"
          prop="bill_unit_id"
          v-if="state.model.payment_method == 1"
          :rules="[
            {
              required: true,
              message: '请选择乙方',
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            v-model="state.model.bill_unit_id"
            placeholder="--请选择--"
          >
            <el-option
              v-for="item in state.yfdw_data"
              :key="item"
              :label="item.name"
              :value="item.id"
              style="height: auto"
            />
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadYfdw()"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
      </ul>
      <ul class="grid grid-cols-3 gap-x-3">
        <el-form-item
          label="财务审批"
          prop="cfo"
          :rules="[
            { required: true, message: '请选择财务审批人', trigger: 'blur' },
          ]"
        >
          <c_userselect v-model="state.model.cfo" :type="2" />
        </el-form-item>
        <el-form-item
          label="总经理审批"
          prop="ceo"
          :rules="[
            {
              required: true,
              message: '请选择总经理审批人',
              trigger: 'blur',
            },
          ]"
        >
          <c_userselect v-model="state.model.ceo" :type="3" />
        </el-form-item>
        <el-form-item
          label="付款出纳"
          prop="cashier_admin_id"
          :rules="[
            { required: true, message: '请选择付款出纳', trigger: 'blur' },
          ]"
        >
          <c_userselect
            v-model="state.model.cashier_admin_id"
            :type="4"
            @change:item="
              (item) => {
                state.model.cashier_department_id = item.department_id;
              }
            "
          />
        </el-form-item>
      </ul>
      <el-form-item label="申请说明">
        <el-input v-model="state.model.intro" type="textarea" />
      </el-form-item>
      <ul
        class="grid items-center"
        style="grid-template-columns: auto 1fr auto auto"
      >
        <strong>费用明细</strong>
        <li>
          <el-button
            type="primary"
            icon="plus"
            link
            @click="state.model.item_data.push({ files: [] })"
          >
            添加明细
          </el-button>
        </li>
        <strong>合计金额：</strong>
        <c_money :value="state.total" :key="state.total" />
      </ul>
      <ul
        v-for="(item, index) in state.model?.item_data"
        :key="item"
        class="mt-2 rounded-lg p-2.5 border grid gap-x-3 relative"
        style="grid-template-columns: 140px 120px 1fr 20%"
      >
        <el-icon
          v-if="state.model?.item_data?.length > 1"
          color="var(--el-color-danger)"
          :size="20"
          class="!absolute right-2 top-2 cursor-pointer hover:scale-110"
          @click="
            state.model.item_data.splice(index, 1);
            onBuildTotal();
          "
        >
          <Delete />
        </el-icon>
        <el-form-item
          label="发生日期"
          size="normal"
          :prop="`item_data.${index}.date`"
          :rules="[
            { required: true, message: '请选择发生日期', trigger: 'blur' },
          ]"
        >
          <el-date-picker
            v-model="item.date"
            type="date"
            placeholder=""
            value-format="YYYY-MM-DD"
            :disabled-date="
              (val) => {
                return $dayjs(val) > $dayjs();
              }
            "
          />
        </el-form-item>
        <el-form-item
          label="费用金额"
          size="normal"
          :prop="`item_data.${index}.money`"
          :rules="[
            { required: true, message: '请输入费用金额', trigger: 'blur' },
          ]"
        >
          <el-input-number
            v-model="item.money"
            :precision="2"
            class="number-input-left number-input-suffix !w-28"
            suffix="元"
            @focus="$onFocus"
            @change="onBuildTotal"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="费用说明" size="normal">
          <el-input v-model="item.intro"></el-input>
        </el-form-item>
        <el-form-item>
          <template #label>
            <div class="flex items-center">
              附件
              <el-upload
                :show-file-list="false"
                :auto-upload="false"
                multiple
                :on-change="
                  (file) => {
                    onFileChange(file, item);
                  }
                "
                class="overflow-hidden"
              >
                <el-button link type="primary" icon="plus">上传</el-button>
              </el-upload>
            </div>
          </template>
          <template v-if="item.files?.length > 0">
            <ul
              v-for="file in item.files"
              :key="file"
              class="grid gap-x-2"
              style="grid-template-columns: 1fr auto"
            >
              <li
                class="overflow-hidden whitespace-nowrap hover:underline cursor-pointer text-green-700"
                style="line-height: 16px"
                :title="file.file_url"
                @click="$openFile(file.file_url)"
              >
                {{ file.origin_filename }}
              </li>
              <el-icon
                color="#f00"
                @click.stop="item.files?.splice(index, 1)"
                class="hover:scale-110 text-red-400 cursor-pointer ml-2"
              >
                <Close />
              </el-icon>
            </ul>
          </template>
          <text v-else class="text-gray-400 text-xs mt-2">请上传附件~</text>
        </el-form-item>
      </ul>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit"> 提交 </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  officeExpenseApply_detail,
  officeExpenseApply_add,
  officeExpenseApply_edit,
} from "@/http/bangongfeiyong";
import { dic_getOfficeExpenseType, data_getBillUnit } from "@/http/data";
import { attachment_upload } from "@/http/attachment";
import { post_response, toDecimal } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        payment_method: 0,
        item_data: [{ files: [] }],
      },
      items: [{}],
    });
    onMounted(() => {
      onLoadLx();
      onLoadYfdw();
      if (props.id) {
        officeExpenseApply_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.files = data.attachment.map((m) => {
              return {
                id: m.id,
                origin_filename: m.filename,
                file_url: m.file_url,
              };
            });
          }
        });
      }
    });

    //获取类型
    const onLoadLx = () => {
      dic_getOfficeExpenseType({ tree: 1 }).then((res) => {
        if (res.status == 200) {
          const { data } = res.data;

          let lx_data = [];
          data.forEach((e) => {
            if (!e.children || e.children.length <= 0) e.disabled = true;
            lx_data.push(e);
          });
          state.lx_data = lx_data;
        }
      });
    };

    const onLxChange = (e) => {
      state.model.d_office_expense_type_pid = e.pid;
    };

    //获取乙方单位
    const onLoadYfdw = () => {
      data_getBillUnit().then((res) => {
        if (res.status == 200) state.yfdw_data = res.data?.data?.list || [];
      });
    };

    const onFileChange = (file, item) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          if (!Array.isArray(item.files)) item.files = [];
          item.files = [...item.files, ...res.data.data];
        }
      });
    };

    //计算总合计
    const onBuildTotal = () => {
      const total = state.model?.item_data?.reduce((pre, cur) => {
        return pre.plus(toDecimal(cur.money?.toString() || ""));
      }, toDecimal("0"));
      state.total = total;
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.item_data?.forEach((item) => {
            item.attachment = item.files.map((m) => m.id);
          });

          if (props.id) {
            officeExpenseApply_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            officeExpenseApply_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onFileChange,
      onLoadLx,
      onLxChange,
      onLoadYfdw,
      onBuildTotal,
    };
  },
};
</script>
<style scoped></style>
